import {
  createContext,
  FC,
  PropsWithChildren,
  useEffect,
  useState,
} from 'react'
import { AmplifyAuth, useAmplifyAuth } from 'lib/auth/use-amplify'
import { APP_MODES, AuthProviderTsp } from '@/main.lib'
import { amplifyConfig } from 'lib/cognito'

export const AuthContext = createContext<AmplifyAuth | null>(null)
// Helper to check and validate SSO
const checkSSO = () => {
  const ssoVerified = sessionStorage.getItem('sso_verified')
  const ssoToken = sessionStorage.getItem('sso_token')

  if (ssoVerified === 'true' && ssoToken) {
    try {
      const payload = JSON.parse(atob(ssoToken.split('.')[1]))

      // Check if token expired
      if (payload.exp * 1000 < Date.now()) {
        // Clear expired token
        sessionStorage.removeItem('sso_token')
        sessionStorage.removeItem('sso_verified')
        return null
      }

      // @ts-ignore
      window.__mode = APP_MODES.UNITY
      return {
        email: payload.email,
        sub: payload.sub,
        name: payload.name || payload['cognito:username'],
        source: sessionStorage.getItem('user_source') || 'master',
        isSSO: true,
      }
    } catch (error) {
      console.error('Invalid SSO token:', error)
      sessionStorage.removeItem('sso_token')
      sessionStorage.removeItem('sso_verified')
      return null
    }
  }

  return null
}

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [ssoUser, setSsoUser] = useState<any>(null)
  const amplify = useAmplifyAuth(amplifyConfig)

  useEffect(() => {
    // Check for SSO session on mount
    const sso = checkSSO()
    if (sso) {
      setSsoUser(sso)
    }
  }, [])

  if (!amplify.isConfigured()) return 'Loading...'

  // Create enhanced amplify object with SSO user if exists
  const enhancedAmplify = {
    ...amplify,
    ssoUser,
    isSSO: !!ssoUser,
    // Override user getter to include SSO
    get user() {
      return ssoUser || amplify.user
    },
  }

  return (
    <AuthContext.Provider value={enhancedAmplify}>
      <AuthProviderTsp amplify={enhancedAmplify}>{children}</AuthProviderTsp>
    </AuthContext.Provider>
  )
}
